import * as React from "react";
import { Button, Container, Box, useTheme, useMediaQuery } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { styled } from "@mui/system";
import logo from "./LogoG.jpg";
import { useNavigate } from "react-router-dom";
import { auth } from "../config/firebase";
import { signOut } from "firebase/auth";

const StyledContainer = styled(Container)(({ theme }) => ({
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#fff",
  fontFamily: "Lato, sans-serif",
  position: "relative",
  padding: theme.spacing(3),
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(2),
  },
}));

const LogoContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginBottom: theme.spacing(6),
  [theme.breakpoints.down("md")]: {
    marginBottom: theme.spacing(4),
  },
}));

const OptionsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "center",
  alignItems: "center",
  gap: theme.spacing(3),
  maxWidth: "900px",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: theme.spacing(2),
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  fontWeight: "500",
  backgroundColor: "#000",
  color: "#fff",
  padding: theme.spacing(2, 4),
  fontSize: "1rem",
  minWidth: "180px",
  height: "52px",
  borderRadius: "4px",
  textTransform: "none",
  transition: "all 0.2s ease",
  "&:hover": {
    backgroundColor: "#333",
    transform: "none",
  },
  [theme.breakpoints.down("md")]: {
    minWidth: "300px",
    fontSize: "1rem",
    height: "48px",
  },
  [theme.breakpoints.down("sm")]: {
    minWidth: "100%",
    maxWidth: "350px",
  },
}));

const LogoutButton = styled(Button)(({ theme }) => ({
  position: "fixed",
  top: theme.spacing(3),
  right: theme.spacing(3),
  color: "#666",
  textTransform: "none",
  fontSize: "0.9rem",
  padding: theme.spacing(1, 2),
  borderRadius: "4px",
  border: "1px solid #e0e0e0",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "#f5f5f5",
    borderColor: "#ccc",
  },
  [theme.breakpoints.down("sm")]: {
    top: theme.spacing(2),
    right: theme.spacing(2),
    fontSize: "0.8rem",
    padding: theme.spacing(0.5, 1.5),
  },
}));

const StyledLogo = styled("img")(({ theme }) => ({
  width: "280px",
  height: "auto",
  maxWidth: "100%",
  [theme.breakpoints.down("md")]: {
    width: "240px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "200px",
  },
}));


const Subtitle = styled("p")(({ theme }) => ({
  fontSize: "1rem",
  color: "#888",
  margin: 0,
  marginBottom: theme.spacing(5),
  textAlign: "center",
  fontWeight: "300",
  [theme.breakpoints.down("md")]: {
    fontSize: "0.9rem",
    marginBottom: theme.spacing(4),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.85rem",
    marginBottom: theme.spacing(3),
  },
}));

function LandingPage() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const logout = async () => {
    try {
      await signOut(auth);
      navigate("/login");
    } catch (err) {
      console.error(err);
    }
  };

  const menuItems = [
    { label: "Invoice", path: "invoice" },
    { label: "Quote", path: "quote" },
    { label: "Spanish Quote", path: "spanish-quote" },
    { label: "BoL", path: "bol" },
    { label: "CCA", path: "send-card-form" },
  ];

  return (
    <StyledContainer maxWidth={false}>
      <LogoutButton startIcon={<LogoutIcon />} onClick={logout}>
        Logout
      </LogoutButton>
      
      <LogoContainer>
        <StyledLogo src={logo} alt="Company Logo" />
      </LogoContainer>

      <Subtitle>Select an option to get started</Subtitle>

      <OptionsContainer>
        {menuItems.map((item, index) => (
          <StyledButton
            key={index}
            variant="contained"
            onClick={() => navigate(item.path)}
            size="large"
          >
            {item.label}
          </StyledButton>
        ))}
      </OptionsContainer>
    </StyledContainer>
  );
}

export default LandingPage;
